import React from 'react';
import { OperationType } from 'api';
import dateTimeFormatter, { getTime } from 'utils/date/dateTimeFormatter';
import useStyles from './RemittanceListStyles';
import { getRemittanceType } from './RemittanceTextHelper';
export default function RemittanceRow({
  id,
  operationType,
  totalPriceVatExcluded,
  totalPriceVatIncluded,
  totalVat,
  productName,
  transactedOn,
  transactionItemType
}) {
  const {
    details,
    column
  } = useStyles();
  const isDebit = operationType === OperationType.Debit;
  const formattedDate = dateTimeFormatter(transactedOn);
  const time = getTime(transactedOn);
  const remittanceType = getRemittanceType(transactionItemType);
  return /*#__PURE__*/React.createElement("div", {
    key: id,
    className: details
  }, /*#__PURE__*/React.createElement("div", {
    className: column
  }, /*#__PURE__*/React.createElement("div", null, remittanceType)), /*#__PURE__*/React.createElement("div", {
    className: column
  }, /*#__PURE__*/React.createElement("div", null, productName), /*#__PURE__*/React.createElement("div", null, formattedDate), /*#__PURE__*/React.createElement("div", null, time)), /*#__PURE__*/React.createElement("div", {
    className: column
  }, /*#__PURE__*/React.createElement("div", null, `${isDebit && !!totalPriceVatExcluded ? '-' : ''}${totalPriceVatExcluded}`), /*#__PURE__*/React.createElement("div", null, "NOK")), /*#__PURE__*/React.createElement("div", {
    className: column
  }, /*#__PURE__*/React.createElement("div", null, `${isDebit && !!totalVat ? '-' : ''}${totalVat}`), /*#__PURE__*/React.createElement("div", null, "NOK")), /*#__PURE__*/React.createElement("div", {
    className: column
  }, /*#__PURE__*/React.createElement("div", null, `${isDebit && !!totalPriceVatIncluded ? '-' : ''}${totalPriceVatIncluded}`), /*#__PURE__*/React.createElement("div", null, "NOK")));
}